<template>
  <PageLoader />
  <AppHeader />
  <Home />
  <AppFooter />
</template>

<script>
import AppHeader from "@/components/layout/AppHeader";
import AppFooter from "@/components/layout/AppFooter";
import PageLoader from "@/components/layout/PageLoader";
import Home from "@/pages/Home";
export default {
  name: "App",
  components: {
    AppHeader,
    AppFooter,
    PageLoader,
    Home,
  },
};
</script>
